/**
 * Party color palette for match flow views.
 *
 * Assigns deterministic colors to party groups so members
 * are visually linked across all flow nodes.
 */

export type PartyColor = {
  ring: string;
  bg: string;
  text: string;
  border: string;
};

const PARTY_COLORS: PartyColor[] = [
  {
    ring: "ring-rose-400/50",
    bg: "bg-rose-500/10",
    text: "text-rose-400",
    border: "border-rose-400/30",
  },
  {
    ring: "ring-violet-400/50",
    bg: "bg-violet-500/10",
    text: "text-violet-400",
    border: "border-violet-400/30",
  },
  {
    ring: "ring-amber-400/50",
    bg: "bg-amber-500/10",
    text: "text-amber-400",
    border: "border-amber-400/30",
  },
  {
    ring: "ring-sky-400/50",
    bg: "bg-sky-500/10",
    text: "text-sky-400",
    border: "border-sky-400/30",
  },
  {
    ring: "ring-emerald-400/50",
    bg: "bg-emerald-500/10",
    text: "text-emerald-400",
    border: "border-emerald-400/30",
  },
  {
    ring: "ring-orange-400/50",
    bg: "bg-orange-500/10",
    text: "text-orange-400",
    border: "border-orange-400/30",
  },
  {
    ring: "ring-pink-400/50",
    bg: "bg-pink-500/10",
    text: "text-pink-400",
    border: "border-pink-400/30",
  },
  {
    ring: "ring-lime-400/50",
    bg: "bg-lime-500/10",
    text: "text-lime-400",
    border: "border-lime-400/30",
  },
];

const MY_PARTY_COLOR: PartyColor = {
  ring: "ring-brand-500/50",
  bg: "bg-brand-500/10",
  text: "text-brand-400",
  border: "border-brand-500/30",
};

function hashPartyId(partyId: string): number {
  let hash = 0;
  for (let i = 0; i < partyId.length; i++) {
    hash = ((hash << 5) - hash + partyId.charCodeAt(i)) | 0;
  }
  return hash >>> 0;
}

/**
 * Get the party color for a given partyId.
 *
 * - Current player's party -> brand teal
 * - Other parties -> deterministic color from palette
 * - No party (null partyId) -> null
 */
export function getPartyColor(partyId: string | null, myPartyId: string | null): PartyColor | null {
  if (!partyId) return null;
  if (partyId === myPartyId) return MY_PARTY_COLOR;
  return PARTY_COLORS[hashPartyId(partyId) % PARTY_COLORS.length];
}
